import { render, staticRenderFns } from "./CoursesContent.vue?vue&type=template&id=be90c0ee&scoped=true"
import script from "./CoursesContent.vue?vue&type=script&lang=js"
export * from "./CoursesContent.vue?vue&type=script&lang=js"
import style0 from "./CoursesContent.vue?vue&type=style&index=0&id=be90c0ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be90c0ee",
  null
  
)

export default component.exports